import { render } from "./TickerComponent.vue?vue&type=template&id=0836a3a8&scoped=true"
import script from "./TickerComponent.vue?vue&type=script&lang=js"
export * from "./TickerComponent.vue?vue&type=script&lang=js"

import "./TickerComponent.vue?vue&type=style&index=0&id=0836a3a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0836a3a8"]])

export default __exports__